<template>
<div>
  
    <div class="row">
      <div class="col-sm-12 col-md-12">
        <el-form v-if="active === 1">
            <app-overlay-loader v-if="preloader" />
            <div class="card-body">
              <form
                class="mb-0"
                :class="{ 'loading-opacity': preloader }"
                ref="form"
                :data-url="addurl"
              >
                <div class="form-group align-items-center">
                    <label class="mb-2">
                      {{ $t("select_users_type") }}
                    </label>
                    <app-input
                      id="inputs_user_type"
                      type="search-select"
                      v-model="select_user_type"
                      :isAnimatedDropdown="true"
                      :required="true"
                      :placeholder="$t('select_users_type')"
                      :list="user_type"
                    />
                </div>
                <div class="form-group align-items-center" v-if="show == true">
                  <label class="mb-2">
                    {{ $t("users") }}
                  </label>
                  <app-input
                    id="inputs_status"
                    type="search-select"
                    v-model="inputs.user_id"
                    :isAnimatedDropdown="true"
                    :required="true"
                    :placeholder="placeholder"
                    :list="internal_users"
                  />
                  <p class="font-italic text-muted" v-if="showAddUser == true">
                    {{ $t("shortcut_user_create") }} <span><a href="#" @click.prevent="addUser()">{{$t("add_user")}}</a></span>
                  </p>
                  <p class="font-italic text-muted" v-if="showShortSupplier == true">
                    {{ $t("shortcut_supplier_shortlist") }} <span><a href="#" @click.prevent="refreshShortList()">{{$t("shortlist")}}</a></span>
                  </p>
                  <p class="font-italic text-muted" v-if="refreshSupplierList == true">
                     <a href="#" @click.prevent="checkUserType()">{{$t("refresh")}}</a><span> {{ $t("shortlisted_suppliers_list") }}</span>
                  </p>
                </div>
                <div class="mt-5 action-buttons" style="text-align: end">
                  <button
                    type="submit"
                    class="btn btn-primary mr-2"
                    @click.prevent="submit"
                  >
                    {{ $t("submit") }}
                  </button>
                </div>
              </form>
              <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <label>{{ $t("assigned_users_list") }}</label>
                  <table class="table">
                    <tr>
                      <th>S.No</th>
                      <th>User Name</th>
                    </tr>
                    <tr v-for="(user, index) in assign_user" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td>{{ user.full_name+' (Role: '+ user.role[0].name + ')' }}</td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
        </el-form>
        <el-form v-if="active === 2">
          <div class="card-body">
            <h3 class="mb-3">{{ $t("add_user") }}</h3>
            <shortcut-user-create :back="backTaskCreate"></shortcut-user-create>
          </div>
        </el-form>
      </div>
    </div>
</div>
</template>

<script>
import { FormMixin } from "../../../../../../core/mixins/form/FormMixin.js";
import {
  INTERNAL_USERS,
  ASSIGN_USER,
  GET_ASSIGNED_USERS,
  SHORTLIST_SUPPLIERS,
} from "../../../../../Config/ApiUrl.js";
import { axiosGet, axiosPost } from "../../../../../Helpers/AxiosHelper.js";

export default {
  name: "FormGrid",
  mixins: [FormMixin],
  data() {
    return {
      active: 1,
      showAddUser: false,
      showShortSupplier: false,
      refreshSupplierList: false,
      addurl: ASSIGN_USER,
      placeholder: '',
      show: false,
      preloader: false,
      inputs: {},
      // user_id: 17,
      internal_users: [],
      assign_user: {},
      select_user_type: '',
      user_type: [
        {id: 'internal_user', value: 'Internal User'},
        {id: 'shortlisted_supplier', value: 'Shortlisted Supplier'}
      ]
    };
  },
  watch: {
    select_user_type() {
      this.checkUserType();
    }
  },
  methods: {
    submit() {
      let formData = new FormData();
      Object.keys(this.inputs).forEach((key) => {
        formData.append(key,this.inputs[key]);
      });
      this.save(formData);
      // axiosPost(ASSIGN_USER, this.inputs)
      //   .then((res) => {
      //     this.$toastr.s(res.data);
      //     this.getAssignedUsers();
      //   })
      //   .catch((error) => {
      //     this.$toastr.e(error);
      //     
      //   });
    },
    afterSuccess(response) {
      this.$toastr.s(response.data);
      this.getAssignedUsers();
    },
    getInternalUsers(url) {
      axiosGet(url)
        .then((res) => {
          this.internal_users = res.data;
        })
        .catch((error) => {
          
        });
    }, 
    getAssignedUsers() {
      let id = this.$attrs['props'].id;
      axiosGet(GET_ASSIGNED_USERS + "/" + id)
        .then((res) => {
          this.assign_user = res.data.users;
        })
        .catch((error) => {
          
        });
    },
    checkUserType() {
      if (this.select_user_type == 'internal_user') {
          this.placeholder = 'Select Internal User';
          let url = INTERNAL_USERS;
          this.getInternalUsers(url);
          this.show = true;
          this.showAddUser = true;
          this.showShortSupplier = false;
          this.refreshSupplierList = false;
      }
      else {
          this.placeholder = 'Select ShortListed Supplier';
          let url = SHORTLIST_SUPPLIERS;
          this.getInternalUsers(url);
          this.show = true;
          this.showAddUser = false;
          this.showShortSupplier = true;
          this.refreshSupplierList = false;
      }
    },
    refreshShortList() {
      this.refreshSupplierList = true;
      this.showShortSupplier = false;
      window.open('/buyer/allsupplier', '_blank');
    },
    backTaskCreate(value) {
      this.checkUserType();
      this.active = 1;
    },
    addUser() {
      this.active = 2;
    },
  },
  mounted() {
    // let myLocation = location.href;
    // let split = myLocation.split("/");
    // let id = split[6].split("?")[0];
    let id = this.$attrs['props'].id;
    this.inputs.job_id = id;
    // this.getInternalUsers();
    this.getAssignedUsers();
  },
  computed: {
    userList() {
      return this.$store.state.user.loggedInUser;
    },
  },
};
</script>
